import React, { FC } from 'react'

const SupabaseUpdater: FC = () => {
  return null
}

export default SupabaseUpdater
